import CompletedPurchase from './CompletedPurchase.vue'
export default {
    'completed-purchase': CompletedPurchase
}
